const homevideoSelectors = {
  video: ".home-video source",
};

const homevideoDesktopMinSize = 500; // px; min viewport width to show the home video desktop version

window.addEventListener("DOMContentLoaded", function() {
  const video = document.querySelector(homevideoSelectors.video);
  if (video) {
    homevideoInit(video);
  }
});

function homevideoInit(video) {
  // console.log('home-video init...');

  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  if (vw > homevideoDesktopMinSize) {
    video.src = video.dataset.srcDesktop;
  } else {
    video.src = video.dataset.srcMobile;
  }
}
